import { FeatureCollection, Point } from 'geojson';

type PlaceInput = {
    id: number;
    name: string;
    center?: Point;
    photo_path?: string | null;
};

export function placesToFeatureCollection(
    places: PlaceInput[],
    visitedPlaceIds?: number[]
): FeatureCollection<Point> {
    const visited = new Set(visitedPlaceIds ?? []);
    const seen = new Set<number>();
    const features: FeatureCollection<Point>['features'] = [];

    for (const place of places) {
        if (seen.has(place.id) || !place.center) continue;
        seen.add(place.id);
        features.push({
            type: 'Feature',
            geometry: place.center,
            properties: {
                name: place.name,
                visited: visited.size > 0 ? visited.has(place.id) : undefined,
                photo_path: place.photo_path ?? undefined,
            },
            id: place.id,
        });
    }

    return { type: 'FeatureCollection', features };
}
